var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "before-and-after-comparison",
          attrs: {
            visible: _vm.visible,
            title: _vm.$t("ChangeCharge.ChangeTheChargesInTheExpenseReview"),
            width: "1300px",
            "close-on-click-modal": false,
            "show-close": false,
            top: "10vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            open: _vm.showDialog,
            close: _vm.resetDialog
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { padding: "0 0 0 10px", height: "28px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "60px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.receivable")))]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { height: "150px", padding: "0" },
              attrs: { id: "vsPage1" }
            },
            [
              _c("cargo-ag-grid", {
                key: "chargeGrid1",
                staticStyle: { height: "150px", width: "100%" },
                attrs: {
                  "config-module": "13011112",
                  "grid-params": _vm.chargeBeforeGrid.gridParams,
                  "grid-options": _vm.chargeBeforeGrid.gridOptions,
                  "column-defs": _vm.chargeBeforeGridColumnDefs,
                  "row-data": _vm.receivableRowData,
                  "show-side-bar": true,
                  "auto-fit-content": false,
                  "min-height": "150"
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.chargeBeforeGrid, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.chargeBeforeGrid, "gridParams", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "padding-right": "10px",
                height: "30px",
                "background-color": "#f5f7f7"
              }
            },
            [
              _c("span", {
                staticStyle: { "font-size": "13px" },
                domProps: {
                  textContent: _vm._s(_vm.$t("CargoMsg.Cargo_AmountToP"))
                }
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    "padding-right": "10px",
                    display: "inline-block",
                    "vertical-align": "middle"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("charge-currency-total-group", {
                        key: 1,
                        attrs: {
                          "amount-to-currency": "RMB",
                          "data-provider": _vm.receivableRowData,
                          type: "ar"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { padding: "0 0 0 10px", height: "28px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "60px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.payable")))]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { height: "150px", padding: "0" },
              attrs: { id: "vsPage2" }
            },
            [
              _c("cargo-ag-grid", {
                key: "chargeGrid2",
                staticStyle: { height: "150px", width: "100%" },
                attrs: {
                  "config-module": "13011113",
                  "grid-params": _vm.chargeAfterGrid.gridParams,
                  "grid-options": _vm.chargeAfterGrid.gridOptions,
                  "column-defs": _vm.chargeAfterGridColumnDefs,
                  "row-data": _vm.payableRowData,
                  "show-side-bar": true,
                  "auto-fit-content": false,
                  "min-height": "150"
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.chargeAfterGrid, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.chargeAfterGrid, "gridParams", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "padding-right": "10px",
                height: "30px",
                "background-color": "#f5f7f7"
              }
            },
            [
              _c("span", {
                staticStyle: { "font-size": "13px" },
                domProps: {
                  textContent: _vm._s(_vm.$t("CargoMsg.Cargo_AmountToP"))
                }
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    "padding-right": "10px",
                    display: "inline-block",
                    "vertical-align": "middle"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("charge-currency-total-group", {
                        key: 2,
                        attrs: {
                          "amount-to-currency": "RMB",
                          "data-provider": _vm.payableRowData,
                          type: "ap"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }